<template>
    <div class="content">
        <div class="loader" v-if="loading"></div>

        <!-- div class="text-left" style="padding: 30px;">
            <img src="img/brand/snap_logo_black.png" alt="logo" style="width: 200px;">

        </div -->


        <nav class="navbar navbar-main navbar-expand-lg navbar-light navbar-transparent">
            <div class="container">
                <a href="#/" class="navbar-brand mr-lg-5 active router-link-active">
                    <img src="img/brand/snap_logo_black.png" alt="logo" style="width: 200px;">
                </a>
                <button type="button" data-toggle="collapse" data-target="0.09348953347041178" aria-controls="0.09348953347041178" aria-label="Toggle navigation" class="navbar-toggler">
                    <span class="navbar-toggler-icon"></span>
                </button>
            </div>
        </nav>



        <b-container fluid class="mt-6">



                                        <wizard-header v-if="currentSnapWizardStep == 0" @allowProceed="allowProceed"
                                            :token="token"></wizard-header>

                                            <snap01_format v-if="currentSnapWizardStep == 1 && formatSet" @allowProceed="allowProceed" @denyProceed="denyProceed" @showFooterNav="showFooterNav" @hideFooterNav="hideFooterNav"></snap01_format>


                                        <snap01 v-if="currentSnapWizardStep == 1 && !formatSet"
                                            @allowProceed="allowProceed" @denyProceed="denyProceed"
                                            @showFooterNav="showFooterNav" @hideFooterNav="hideFooterNav"></snap01>

                                        <snap02 v-if="currentSnapWizardStep == 2" @allowProceed="allowProceed"
                                            @denyProceed="denyProceed" @showFooterNav="showFooterNav"
                                            @hideFooterNav="hideFooterNav"></snap02>

                                        <snap03 v-if="currentSnapWizardStep == 3" @allowProceed="allowProceed"
                                            @denyProceed="denyProceed" @showFooterNav="showFooterNav"
                                            @hideFooterNav="hideFooterNav"></snap03>

                                        <snap04 v-if="currentSnapWizardStep == 4" @allowProceed="allowProceed"
                                            @denyProceed="denyProceed" @showFooterNav="showFooterNav"
                                            @hideFooterNav="hideFooterNav"></snap04>

                                        <snap05 v-if="currentSnapWizardStep == 5" @allowProceed="allowProceed"
                                            @denyProceed="denyProceed" @showFooterNav="showFooterNav"
                                            @hideFooterNav="hideFooterNav"></snap05>

                                        <snap06 v-if="currentSnapWizardStep == 6" @allowProceed="allowProceed"
                                            @denyProceed="denyProceed" @showFooterNav="showFooterNav"
                                            @hideFooterNav="hideFooterNav"></snap06>

                                            <div class="container">
                                                <div  v-if="show_footer_button">

<a href="javascript:void(0);" class="btn btn-dark" @click="nextStep" :disabled="!mayProceed"
    v-if="show_footer_button">Continue</a>

                                            </div>
                                            </div>
                                            

        </b-container>
    </div>
</template>
<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import Badge from '@/components/Badge';


import moment from 'moment'
import AppStyle from '@/plugins/appStyle';
import WizardHeader from '@/views/Pages/SnapFormWizardSmall/WizardHeader';

// import note from '@/views/Pages/SnapFormWizard/Steps/note';

import snap01_format from '@/views/Pages/SnapFormWizard/Steps/snap01_format';
import snap01 from '@/views/Pages/SnapFormWizardSmall/Steps/snap01';
import snap02 from '@/views/Pages/SnapFormWizardSmall/Steps/snap02';
import snap03 from '@/views/Pages/SnapFormWizardSmall/Steps/snap03';
import snap04 from '@/views/Pages/SnapFormWizardSmall/Steps/snap04';
import snap05 from '@/views/Pages/SnapFormWizardSmall/Steps/snap05';
import snap06 from '@/views/Pages/SnapFormWizardSmall/Steps/snap06';


export default {
    name: 'snap-form-wizard-small',
    mixins: [AppStyle.Mixin],
    components: {
        RouteBreadCrumb,
        snap01_format,
        snap01,
        snap02,
        snap03,
        snap04,
        snap05,
        snap06,
        WizardHeader,
    },
    data() {
        return {
            loading: false,
            allDataValidated: false,
            show_footer_button: false,
            sfid: '',
        }
    },
    props: {
        format: String,
        token: String,
        referral: String,
        pa_name: String,
    },
    methods: {
        toggleOptions() {
            if (this.showOptions) {
                this.showOptions = false;
            }
            else {
                this.showOptions = true;
            }
        },
        allowProceed() {
            console.log("allowing proceed");
            this.allDataValidated = true;
        },
        denyProceed() {
            console.log("denying proceed");
            this.allDataValidated = false;
        },
        showFooterNav() {
            console.log("show footer navigsation");
            this.show_footer_button = true;
        },
        hideFooterNav() {
            console.log("hide footer navigsation");
            this.show_footer_button = false;
        },
        nextStep() {
            // update title
            // reload title && show next step
            this.currentSnapWizard.smform = 1;
            console.log("STEP ----------> " + this.currentSnapWizardStep);
            // but not when we re deciding format
            
            /*if (this.currentSnapWizardStep >= 1) {
                this.loading = true;
                console.log("Perform next step");
                console.log(this.currentSnapWizardStep);

                this.$store.dispatch('snapWizardNextStep');
                this.loading = false;
            }*/
            // but not when we re deciding format
            if((this.currentSnapWizard.format === "a4" || this.currentSnapWizard.format === "30x30") && this.currentSnapWizardStep >= 1){
                this.loading = true;
                console.log("Perform next step");
                console.log(this.currentSnapWizardStep);

                this.$store.dispatch('snapWizardNextStep');
                this.loading = false;
            }

        },
        prevStep() {   
            this.loading = true;
            this.$store.dispatch('snapWizardPrevStep');
            this.loading = false;
        },
        getClass() {
            if (this.currentSnapWizardStep == 0) {
                return "pink";
            }
            return "";
        }
    },
    computed: {
        ...mapGetters({
            currentSettings: 'currentSettings',
            currentSnapWizard: 'currentSnapWizard',
            currentSnapWizardStep: 'currentSnapWizardStep',
        }),
        ...mapState(
            {
                snap_wizard: (state) => state.snap_wizard,
            }),

        next_step: (state) => state.snap_wizard.current_step,
        formatSet() {
            if (this.currentSnapWizard.format != '' && this.currentSnapWizard.format != 'null' && typeof this.currentSnapWizard.format != "undefined") {
                return false
            }
            return true
        },
        mayProceed: function () {
            return this.allDataValidated;
        },
        mayGoBack: function () {
            return this.allDataValidated;
        },
    },
    watch: {
        next_step(newValue, oldValue) {
            console.log('queryParameter next_step changed from: ' + oldValue + ' -> ' + newValue);
            nextStep();
        },
        formatSet(){
            if(this.currentSnapWizard.format != '' && this.currentSnapWizard.format != 'null' && typeof this.currentSnapWizard.format != "undefined"){
                return false
            }
            return true
        },
    },
    mounted() {
        this.currentSnapWizard.referral = this.token;
    },
    created() {
    },
}
</script>
<style>
.card {
  -webkit-box-shadow: none;
  box-shadow: none;
  border: 0;
}
body {
  /* background-image: url('../../../public/img/custom/mumm_sm.png');
  background-repeat: no-repeat;*/
}
</style>